import { render, staticRenderFns } from "./ViewNigerianSchools.vue?vue&type=template&id=3720b5f7"
import script from "./ViewNigerianSchools.vue?vue&type=script&lang=js"
export * from "./ViewNigerianSchools.vue?vue&type=script&lang=js"
import style0 from "./ViewNigerianSchools.vue?vue&type=style&index=0&id=3720b5f7&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports